import { render, staticRenderFns } from "./FloodDiagram.vue?vue&type=template&id=2487a6f5&"
import script from "./FloodDiagram.vue?vue&type=script&lang=js&"
export * from "./FloodDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports